import { useQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY, TOKEN_SCOPE } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { Region } from '../constants';

type UseAccessibleRegionOptions = UseQueryOptions<Region[]>;

/**
 * 현재 사용자가 접근할 수 있는 리전 목록을 제공하는 훅입니다.
 * @description
 * - Meta Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const useAccessibleRegion = (options?: UseAccessibleRegionOptions) => {
  const { state } = useServiceAppState();

  const { fetchAccessibleRegion } = useMetaApiInstance();

  return useQuery<Region[]>({
    queryKey: [HOST_QUERY_KEY.GET_ACCESSIBLE_REGION],
    queryFn: fetchAccessibleRegion,
    staleTime: Infinity,
    enabled: state.scope === TOKEN_SCOPE.PROJECT,
    ...options,
  });
};

export default useAccessibleRegion;
